import { Undergrounds } from '../../components/Undergrounds';
import { useOfferContext } from '../OfferContext';

export const UndergroundsContainer = () => {
  const {
    geo: { undergrounds, regionId },
  } = useOfferContext();

  if (!undergrounds.length) {
    return null;
  }

  return <Undergrounds undergrounds={undergrounds} regionId={regionId} />;
};
